<template lang="pug">
    //- Row(type="flex" justify="start")
    Row(style="background-color: #eee;padding:20px" type="flex" justify="space-between")
        Col(span="11")
            Card.imageCard(:bordered="false" style="min-height: 350px;max-height:800px" dis-hover )
                pre(slot="title") {{$t("groupPattern.default")}}
                Button(slot="extra" @click="$emit('input',0)" :disabled="value == 0||disabled" ) {{ value == 0 ? $t("groupPattern.applied"): $t("groupPattern.apply")}}
                img(src="../../../static/customizeTemplate/no-image.png" v-real-img="defaultImgUrl" style="max-height: 200px;max-width: 100%")
        Col(span="11")
            Card.imageCard(:bordered="false" style="min-height: 350px;max-height:800px" dis-hover )
                pre(slot="title") {{$t("groupPattern.customize")}}
                div(slot="extra")
                    Button(@click="clearImage" icon="md-trash" )
                    Button( @click="$emit('input',1)" :disabled="value == 1")  {{ value == 1 ? $t("groupPattern.applied"): $t("groupPattern.apply")}}
                img(src="../../../static/customizeTemplate/no-image.png" v-real-img="previewImg" style="max-height: 200px;max-width: 100%" v-if="!isCleared")
                Upload(
                        :format="uploadImageItem.handleUpload.format"
                        name="uploads"
                        ref="uploads"
                        :on-success="uploadSuccess"
                        :on-format-error="handleFormatError"
                        :multiple="false"
                        :action="`/api/uploads/${uploadImageItem.uploadEndPoint}?groupName=${groupName}`"
                        :before-upload="(...args) => { handleBeforeUpload(uploadImageItem, ...args); }"
                        :show-upload-list="false"
                        v-bind:with-credentials="true")
                        Button(
                            :disabled="disabled"
                            icon="ios-cloud-upload-outline"
                            style="width: 100%;") {{uploadImageItem.handleUpload.format | arrayToString}}


</template>
<script>
import { getGroupPrefs, clearGroupImage } from "@/api/group";

export default {
    props: ["groupName", "value", "uploadImageItem", "disabled"],
    data() {
        return {
            defaultImgUrl: "",
            defaultImageData: {},
            previewImg: "",
            isCleared: false,
        };
    },
    filters: {
        arrayToString: function (text) {
            return Array.isArray(text) ? text.join(", ") : text;
        },
    },
    methods: {
        clearImage() {
            this.$Modal.confirm({
                title: "移除圖片",
                content: `您確定要移除目前的${this.uploadImageItem.handleUpload.successUpdateFields[0]}嗎?`,
                okText: "確定",
                onOk: async () => {
                    this.isCleared = true;
                    await clearGroupImage({
                        type: this.uploadImageItem.handleUpload.successUpdateFields[0],
                        groupName: this.groupName,
                    })
                        .then((result) => {
                            this.$Notice.success({
                                title: this.$i18n.t("global.success"),
                                desc: `${result.data.message}`,
                            });
                            this.getCustomizeImg();
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                },
            });
        },
        // setDefaultImage(urlKey) {
        //     this.defaultImageData[urlKey] = this.defaultImgUrl;
        //     this.previewImg = this.defaultImgUrl;
        //     // 清空方才上傳的圖片資訊
        //     this.defaultImageData[this.uploadImageItem.handleUpload.successUpdateFields[0]] = {};
        //     // 傳送本欄位更新事件
        //     this.$emit("input", this.defaultImageData);
        // },
        getDefaultImg() {
            getGroupPrefs({ type: "default", groupName: this.groupName })
                .then((result) => {
                    this.defaultImgUrl = result.data.img[this.uploadImageItem.currentImageUrlKey];
                    // console.log(this.defaultImgUrl);
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        getCustomizeImg() {
            getGroupPrefs({ type: "customize", groupName: this.groupName })
                .then((result) => {
                    this.isCleared = false;
                    this.previewImg = result.data.img[this.uploadImageItem.currentImageUrlKey];
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handleFormatError(file) {
            this.$Notice.warning({
                title: this.$t("global.errorFile"),
                desc: `${file.name} ` + this.$t("rcmtable.validateUnsupportedText"),
            });
        },
        uploadSuccess(response, file, fileList) {
            if (response.success == false) {
                // 更新指定欄位
                this.uploadImageItem.handleUpload.successUpdateFields.forEach((key) => {
                    this.defaultImageData[key] = "";
                });
                return this.$Notice.warning({
                    title: this.$i18n.t("global.errorFile"),
                    desc: `${response.message}`,
                });
            }
            // 更新指定欄位
            // this.formItem.uploadImageItem.handleUpload.successUpdateFields.forEach(key => {
            //     this.defaultImageData[key] = response.uploadPerformResult;
            // });
            this.$Notice.success({
                title: this.$i18n.t("global.success"),
                desc: `${response.message}`,
            });
            // this.$emit("input", 1);
        },
        //上傳前做圖片預覽後再繼續上傳
        handleBeforeUpload(uploadItem, file) {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const _base64 = reader.result;
                this.previewImg = _base64;
            };
            return true;
        },
    },
    mounted() {
        this.getDefaultImg();
        this.getCustomizeImg();
    },
};
</script>
<style scoped>
.imageCard >>> .ivu-card-body {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/GroupPatternFormItems/ImageUpload.vue